module.exports = __webpack_public_path__ + "img/sidang-accept.233ff790.png";